<template>
  <div>
    <div class="nk-app-root">
      <div class="nk-main">
        <div class="nk-wrap">
          <Header v-show="!loading_page" />
          <div class="nk-content">
            <div class="container wide-xl">
              <div class="nk-content-inner">
                <Navigation v-show="!loading_page" />
                <div class="nk-content-body" v-show="!loading_page">
                  <div class="nk-content-wrap">
                    <div class="nk-block nk-block-lg">
                      <div class="nk-block-head">
                        <div class="nk-block-head-content d-flex justify-content-between align-items-center">
                          <h4 class="nk-block-title">{{ $t('dm_dokumente_title') }}</h4>
                          <button v-if="canDmEdit" class="btn btn-sm btn-primary" @click="openUploadModal">
                            <em class="icon ni ni-upload"></em> {{ $t('dm_dokumente_btn_upload') }}
                          </button>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-sm-4">
                          <input type="text" class="form-control" :placeholder="$t('dm_common_quick_filter')" v-model="quickFilterText" />
                        </div>
                        <div class="col-sm-3">
                          <select class="form-control" v-model="filterTyp" @change="loadDokumente">
                            <option value="">{{ $t('dm_common_all_types') }}</option>
                            <option value="gutachten">{{ $t('dm_dokumente_type_expert_opinion') }}</option>
                            <option value="pruefbericht">{{ $t('dm_dokumente_type_inspection_report') }}</option>
                            <option value="vertrag">{{ $t('dm_dokumente_type_contract') }}</option>
                            <option value="sonstiges">{{ $t('dm_dokumente_type_other') }}</option>
                          </select>
                        </div>
                        <div class="col-sm-3">
                          <select class="form-control" v-model="filterQuelle" @change="loadDokumente">
                            <option value="">{{ $t('dm_dokumente_all_sources') }}</option>
                            <option value="intern">{{ $t('dm_dokumente_source_internal') }}</option>
                            <option value="betreiber">{{ $t('dm_dokumente_source_operator') }}</option>
                            <option value="MaStR">MaStR</option>
                            <option value="PDB">PDB</option>
                            <option value="PDB2">PDB2</option>
                          </select>
                        </div>
                      </div>

                      <div class="card card-bordered">
                        <div class="dm-table-wrap">
                          <table class="dm-table">
                            <thead>
                              <tr>
                                <th v-for="col in tableColumns" :key="col.field" @click="toggleSort(col.field)" class="dm-table-th">
                                  {{ col.label }}
                                  <span v-if="sortField === col.field" class="dm-sort-icon">{{ sortAsc ? '&#9650;' : '&#9660;' }}</span>
                                </th>
                                <th class="dm-table-th" style="width: 80px;"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="row in filteredData" :key="row._id" class="dm-table-row">
                                <td v-for="col in tableColumns" :key="col.field" :class="col.tdClass">
                                  <template v-if="col.field === 'dokument.dateiname'">
                                    <a href="#" @click.prevent="openDokument(row)" class="datei-link" :title="getCellValue(row, col)">
                                      <em class="icon ni" :class="dateiIcon(row)" :style="{ color: dateiIconColor(row) }"></em>
                                      {{ getCellValue(row, col) }}
                                    </a>
                                  </template>
                                  <template v-else>{{ getCellValue(row, col) }}</template>
                                </td>
                                <td class="td-actions">
                                  <a v-if="canDmEdit" href="#" @click.prevent="openEditModal(row)" :title="$t('dm_common_link_edit')" class="btn-icon-action">
                                    <em class="icon ni ni-edit"></em>
                                  </a>
                                  <a href="#" @click.prevent="downloadDokument(row)" :title="$t('dm_common_link_download')" class="btn-icon-action">
                                    <em class="icon ni ni-download"></em>
                                  </a>
                                </td>
                              </tr>
                              <tr v-if="filteredData.length === 0">
                                <td :colspan="tableColumns.length + 1" class="text-center text-muted py-4">{{ $t('dm_common_no_entries_found') }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal fade" tabindex="-1" id="modalDokument">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <a href="#" class="close" data-dismiss="modal" aria-label="Close">
                          <em class="icon ni ni-cross"></em>
                        </a>
                        <div class="modal-header">
                          <h5 class="modal-title">{{ $t('dm_dokumente_modal_upload_title') }}</h5>
                        </div>
                        <div class="modal-body">
                          <div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>
                          <div class="row gy-4">
                            <div class="col-sm-8">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_dokumente_label_system') }}</label>
                                <select id="cbAnlageSelect" class="form-control" v-model="uploadData.anlage_id" data-search="on">
                                  <option value="">{{ $t('dm_dokumente_no_assignment') }}</option>
                                  <option v-for="a in anlagen" :key="a._id" :value="a._id">{{ a.seriennummer }}{{ a.standort && a.standort.name ? ' — ' + a.standort.name : '' }}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_common_col_type') }}</label>
                                <select class="form-control" v-model="uploadData.typ">
                                  <option value="">{{ $t('dm_dokumente_no_type') }}</option>
                                  <option value="gutachten">{{ $t('dm_dokumente_type_expert_opinion') }}</option>
                                  <option value="pruefbericht">{{ $t('dm_dokumente_type_inspection_report') }}</option>
                                  <option value="vertrag">{{ $t('dm_dokumente_type_contract') }}</option>
                                  <option value="sonstiges">{{ $t('dm_dokumente_type_other') }}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row gy-4 mt-2">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_dokumente_label_source') }}</label>
                                <select class="form-control" v-model="uploadData.quelle">
                                  <option value="intern">{{ $t('dm_dokumente_source_internal') }}</option>
                                  <option value="betreiber">{{ $t('dm_dokumente_source_operator') }}</option>
                                  <option value="MaStR">MaStR</option>
                                  <option value="PDB">PDB</option>
                                  <option value="PDB2">PDB2</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_dokumente_label_visible_for') }}</label>
                                <select class="form-control" v-model="uploadData.sichtbar_fuer">
                                  <option value="intern">{{ $t('dm_dokumente_source_internal') }}</option>
                                  <option value="betreiber">{{ $t('dm_dokumente_source_operator') }}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="form-group mt-3">
                            <label class="form-label">{{ $t('dm_common_col_description') }}</label>
                            <textarea class="form-control" v-model="uploadData.beschreibung" rows="2"></textarea>
                          </div>
                          <div class="form-group mt-3">
                            <label class="form-label">{{ $t('dm_common_col_filename') }} <span class="text-muted small">{{ $t('dm_dokumente_max_file_size') }}</span></label>
                            <input type="file" class="form-control" ref="fileInput" @change="onFileSelected" />
                          </div>
                        </div>
                        <div class="modal-footer bg-light d-flex justify-content-end">
                          <button type="button" class="btn btn-sm btn-secondary mr-2" data-dismiss="modal">{{ $t('dm_common_btn_close') }}</button>
                          <button type="button" class="btn btn-sm btn-primary" @click="uploadDokumentAction" :disabled="uploading">
                            {{ uploading ? $t('dm_dokumente_btn_uploading') : $t('dm_dokumente_btn_upload') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal fade" tabindex="-1" id="modalEditDokument">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <a href="#" class="close" data-dismiss="modal" aria-label="Close">
                          <em class="icon ni ni-cross"></em>
                        </a>
                        <div class="modal-header">
                          <h5 class="modal-title">{{ $t('dm_dokumente_modal_edit_title') }}</h5>
                        </div>
                        <div class="modal-body">
                          <div class="alert alert-danger" v-if="editError">{{ editError }}</div>
                          <div class="form-group">
                            <label class="form-label">{{ $t('dm_common_col_filename') }}</label>
                            <input type="text" class="form-control" disabled :value="editData.dokument && editData.dokument.dateiname" />
                          </div>
                          <div class="row gy-4 mt-2">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_common_col_type') }}</label>
                                <select class="form-control" v-model="editData.typ">
                                  <option value="">{{ $t('dm_dokumente_no_type') }}</option>
                                  <option value="gutachten">{{ $t('dm_dokumente_type_expert_opinion') }}</option>
                                  <option value="pruefbericht">{{ $t('dm_dokumente_type_inspection_report') }}</option>
                                  <option value="vertrag">{{ $t('dm_dokumente_type_contract') }}</option>
                                  <option value="sonstiges">{{ $t('dm_dokumente_type_other') }}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_dokumente_label_source') }}</label>
                                <select class="form-control" v-model="editData.quelle">
                                  <option value="intern">{{ $t('dm_dokumente_source_internal') }}</option>
                                  <option value="betreiber">{{ $t('dm_dokumente_source_operator') }}</option>
                                  <option value="MaStR">MaStR</option>
                                  <option value="PDB">PDB</option>
                                  <option value="PDB2">PDB2</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row gy-4 mt-2">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label class="form-label">{{ $t('dm_dokumente_label_visible_for') }}</label>
                                <select class="form-control" v-model="editData.sichtbar_fuer">
                                  <option value="intern">{{ $t('dm_dokumente_source_internal') }}</option>
                                  <option value="betreiber">{{ $t('dm_dokumente_source_operator') }}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="form-group mt-3">
                            <label class="form-label">{{ $t('dm_common_col_description') }}</label>
                            <textarea class="form-control" v-model="editData.beschreibung" rows="2"></textarea>
                          </div>
                        </div>
                        <div class="modal-footer bg-light d-flex justify-content-between">
                          <div>
                            <button v-if="canDmManage" type="button" class="btn btn-sm btn-outline-danger" @click="deleteDokumentAction">
                              <em class="icon ni ni-trash"></em> {{ $t('dm_common_btn_delete') }}
                            </button>
                          </div>
                          <div>
                            <button type="button" class="btn btn-sm btn-secondary mr-2" data-dismiss="modal">{{ $t('dm_common_btn_close') }}</button>
                            <button type="button" class="btn btn-sm btn-primary" @click="saveEditDokument">{{ $t('dm_common_btn_update') }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../../components/Header.vue";
import Navigation from "../../../components/Navigation.vue";
import Footer from "../../../components/Footer.vue";
import dmTableMixin from "@/mixins/dm-table-mixin";
import dmPermissionsMixin from "@/mixins/dm-permissions-mixin";
import { getDokumenteList, getDokumentDownloadUrl, uploadDokument, updateDokument, deleteDokument, getAnlagenList } from "@/services/dm.service";

export default {
  name: "DmDokumente",
  components: { Header, Navigation, Footer },
  mixins: [dmTableMixin, dmPermissionsMixin],
  data() {
    return {
      fullLoader: null,
      dokumente: [],
      anlagen: [],
      filterTyp: "",
      filterQuelle: "",
      uploadData: { typ: "", quelle: "intern", sichtbar_fuer: "intern", anlage_id: "" },
      selectedFile: null,
      uploading: false,
      errorMessage: "",
      editData: {},
      editError: "",
    };
  },
  computed: {
    tableColumns() {
      return [
        { label: this.$t('dm_common_col_serial_number'), field: "seriennummer" },
        { label: this.$t('dm_common_col_system_type'), field: "anlage_typ" },
        { label: this.$t('dm_common_col_filename'), field: "dokument.dateiname", tdClass: "td-truncate" },
        { label: this.$t('dm_common_col_type'), field: "dokument.typ" },
        { label: this.$t('dm_common_col_source'), field: "dokument.quelle" },
        { label: this.$t('dm_dokumente_label_visible_for'), field: "dokument.sichtbar_fuer", formatter: function(val) { return Array.isArray(val) ? val.join(", ") : val || ""; } },
        { label: this.$t('dm_common_col_description'), field: "dokument.beschreibung", tdClass: "td-truncate" },
        { label: this.$t('dm_dokumente_col_uploaded_at'), field: "erstellt_am", formatter: function(val) { return val ? new Date(val).toLocaleDateString("de-DE") : ""; } },
      ];
    },
    loading_page() {
      return this.$store.state.loading_page && this.$store.state.loading_page == "setup";
    },
    filteredData() {
      return this.filterAndSort(this.dokumente, this.tableColumns);
    },
  },
  created() {
    this.loadDokumente();
    this.loadAnlagen();
  },
  methods: {
    loadAnlagen() {
      getAnlagenList({}).then((d) => {
        if (d.data && d.data.list) this.anlagen = d.data.list;
      }).catch(() => {});
    },
    loadDokumente() {
      this.showLoader();
      var filters = {};
      if (this.filterTyp) filters.typ = this.filterTyp;
      if (this.filterQuelle) filters.quelle = this.filterQuelle;
      getDokumenteList(filters)
        .then((d) => {
          this.hideLoader();
          if (d.data && d.data.list) this.dokumente = d.data.list;
        })
        .catch((e) => {
          this.hideLoader();
          this.$store.dispatch("api_error", e);
        });
    },
    initAnlageSelect() {
      this.$nextTick(() => {
        $("#cbAnlageSelect").select2({ dropdownParent: $("#modalDokument") });
        let ref = this;
        $("#cbAnlageSelect").on("change", function () {
          ref.uploadData.anlage_id = $(this).val();
        });
      });
    },
    openUploadModal() {
      this.errorMessage = "";
      this.uploadData = { typ: "", quelle: "intern", sichtbar_fuer: "intern", anlage_id: "", beschreibung: "" };
      this.selectedFile = null;
      $("#modalDokument").modal("show");
      this.initAnlageSelect();
    },
    onFileSelected(event) {
      this.selectedFile = event.target.files[0] || null;
    },
    uploadDokumentAction() {
      if (!this.selectedFile) {
        this.errorMessage = this.$t('dm_dokumente_error_select_file');
        return;
      }
      this.uploading = true;
      this.errorMessage = "";
      var formData = new FormData();
      formData.append("file", this.selectedFile);
      var selectedAnlage = this.anlagen.find(function(a) { return a._id === this.uploadData.anlage_id; }.bind(this));
      if (selectedAnlage) {
        formData.append("seriennummer", selectedAnlage.seriennummer || "");
        formData.append("anlage_id", this.uploadData.anlage_id);
        if (selectedAnlage.typ) formData.append("anlage_typ", selectedAnlage.typ);
      }
      if (this.uploadData.typ) formData.append("typ", this.uploadData.typ);
      formData.append("quelle", this.uploadData.quelle || "intern");
      formData.append("sichtbar_fuer", this.uploadData.sichtbar_fuer || "intern");
      formData.append("beschreibung", this.uploadData.beschreibung || "");
      uploadDokument(formData)
        .then((d) => {
          this.uploading = false;
          var err = this.getApiError(d); if (err) { this.errorMessage = err; }
          else { $("#modalDokument").modal("hide"); this.loadDokumente(); }
        })
        .catch(() => {
          this.uploading = false;
          this.errorMessage = this.$t('dm_dokumente_error_upload_failed');
        });
    },
    dateiIcon(row) {
      var name = (row.dokument && row.dokument.dateiname || "").toLowerCase();
      if (name.endsWith(".pdf")) return "ni-file-pdf";
      if (name.endsWith(".xlsx") || name.endsWith(".xls") || name.endsWith(".csv")) return "ni-file-xls";
      if (name.endsWith(".docx") || name.endsWith(".doc")) return "ni-file-doc";
      if (name.endsWith(".jpg") || name.endsWith(".jpeg") || name.endsWith(".png") || name.endsWith(".gif")) return "ni-img";
      if (name.endsWith(".zip") || name.endsWith(".rar") || name.endsWith(".7z")) return "ni-file-zip";
      return "ni-file";
    },
    dateiIconColor(row) {
      var name = (row.dokument && row.dokument.dateiname || "").toLowerCase();
      if (name.endsWith(".pdf")) return "#E53E3E";
      if (name.endsWith(".xlsx") || name.endsWith(".xls") || name.endsWith(".csv")) return "#38A169";
      if (name.endsWith(".docx") || name.endsWith(".doc")) return "#3182CE";
      if (name.endsWith(".jpg") || name.endsWith(".jpeg") || name.endsWith(".png") || name.endsWith(".gif")) return "#D69E2E";
      if (name.endsWith(".zip") || name.endsWith(".rar") || name.endsWith(".7z")) return "#805AD5";
      return "#718096";
    },
    openDokument(row) {
      var url = getDokumentDownloadUrl(row._id);
      window.open(url, "_blank");
    },
    downloadDokument(row) {
      var url = getDokumentDownloadUrl(row._id);
      window.open(url, "_blank");
    },
    openEditModal(row) {
      this.editError = "";
      this.editData = {
        _id: row._id,
        dokument: row.dokument ? JSON.parse(JSON.stringify(row.dokument)) : {},
        typ: row.dokument && row.dokument.typ || "",
        quelle: row.dokument && row.dokument.quelle || "intern",
        sichtbar_fuer: Array.isArray(row.dokument && row.dokument.sichtbar_fuer) ? row.dokument.sichtbar_fuer[0] || "intern" : row.dokument && row.dokument.sichtbar_fuer || "intern",
        beschreibung: row.dokument && row.dokument.beschreibung || "",
      };
      $("#modalEditDokument").modal("show");
    },
    saveEditDokument() {
      this.editError = "";
      var update = {
        "dokument.typ": this.editData.typ,
        "dokument.quelle": this.editData.quelle,
        "dokument.sichtbar_fuer": [this.editData.sichtbar_fuer],
        "dokument.beschreibung": this.editData.beschreibung,
      };
      updateDokument(this.editData._id, update)
        .then((d) => {
          var err = this.getApiError(d); if (err) { this.editError = err; }
          else { $("#modalEditDokument").modal("hide"); this.loadDokumente(); }
        })
        .catch(() => {
          this.editError = this.$t('dm_common_error_save_failed');
        });
    },
    deleteDokumentAction() {
      this.$swal({
        title: this.$t('dm_dokumente_confirm_delete_title'),
        text: this.$t('dm_dokumente_confirm_delete_text'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: this.$t('dm_common_btn_delete_yes'),
        cancelButtonText: this.$t('dm_common_btn_cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          deleteDokument(this.editData._id).then(() => {
            $("#modalEditDokument").modal("hide");
            this.loadDokumente();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.dm-table-wrap {
  max-height: calc(100vh - 220px);
  overflow: auto;
}

.dm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  table-layout: fixed;
}

.dm-table th,
.dm-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dm-table thead {
  background: #f8f9fa;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 1;
}

.dm-table-th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.dm-table-th:hover {
  color: #334155;
}

.dm-sort-icon {
  font-size: 10px;
  margin-left: 4px;
  color: #E8751A;
}

.dm-table tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}

.dm-table-row {
  transition: background 0.15s;
}

.dm-table-row:hover {
  background: #f8fafc;
}

.td-truncate {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.datei-link {
  color: #334155;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.datei-link:hover {
  color: #E8751A;
}

.td-actions {
  white-space: nowrap;
  text-align: right;
}

.btn-icon-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  color: #64748b;
  transition: all 0.15s;
}

.btn-icon-action:hover {
  background: #f1f5f9;
  color: #E8751A;
}
</style>
